import React from 'react'
import { Stack } from 'react-bootstrap'
import { Icon } from '@ztechapps/webui.util'

import styles from './NotificationDropdown.module.scss'

export const NotificationDropdownEmpty = () => {
  return (
    <Stack className={`${styles.emptyState} text-body-secondary px-3 align-items-center justify-content-center`}>
      <div className={`${styles.emptyIcon} mb-2`}>
        <Icon name="bell-slash" />
      </div>
      <div>No notifications</div>
    </Stack>
  )
}
